import { render } from "./residueCard.vue?vue&type=template&id=323cfaa0&scoped=true"
import script from "./residueCard.vue?vue&type=script&lang=js"
export * from "./residueCard.vue?vue&type=script&lang=js"

import "./residueCard.vue?vue&type=style&index=0&id=323cfaa0&scoped=true&lang=css"

import exportComponent from "/data/PDBcov/VueJs/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-323cfaa0"]])

export default __exports__